import { SVGProps, Ref, forwardRef } from 'react';

export const ExclamationTriangleFilledSize24Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="m1.844 17.047 6.67-11.91C10.056 2.378 10.828 1 12 1s1.943 1.379 3.487 4.136l6.669 11.911c1.484 2.65 2.226 3.976 1.647 4.965S21.706 23 18.67 23H5.331c-3.037 0-4.555 0-5.134-.988-.58-.989.163-2.314 1.647-4.965M11.11 15.4V7.9h1.8v7.5zm.9 1.5a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5"
                    fill="currentColor"
                />
            </g>
        </svg>
    )
);
ExclamationTriangleFilledSize24Glyph.displayName = 'ExclamationTriangleFilledSize24Glyph';
